import {lazyInject} from "@athena-portal/core";
import {CustomProperty, ICustomerPortalService, Party, PaymentCard, Types, MAIN_PAYMENT_CARD} from "@falcon/services";
import * as React from "react";
import {Link} from "react-router-dom";
import {CardReuseCheckbox} from "../CardReuseCheckbox";
import {CreditCardSection} from "../CreditCardSection";

interface IProps {
    party?: Party,
}

interface IState {
    reuseCard?: boolean,
    party?: Party,
    mainCardId?: string,
    mainPaymentCard?: PaymentCard
}

export class SubscriptionPaymentCardsSection extends React.Component<IProps, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IProps) {
        super(props);

        window.sessionStorage.setItem("product", "subscription");
        window.sessionStorage.setItem("payment", "monthly");

        this.state = {}

        this.refreshParty = this.refreshParty.bind(this);
        this.setMainPaymentCard = this.setMainPaymentCard.bind(this);
    }

    public componentDidMount(): void {
        if (this.props.party) {
            this.setMainPaymentCard(this.props.party);

            this.setState({
                party: this.props.party,
                reuseCard: this.props.party.reuseCard
            })
        }
    }

    public componentDidUpdate(): void {
        if (this.state.party === undefined) {
            this.refreshParty();
            setTimeout(() => {
                this.refreshParty();
            }, 1000);
        }
    }

    public render(): React.ReactNode {
        return (
            <div className="text-center mt-4">
                <img className="icon product-section-img" src="/img/payment-card-icon.png" alt="credit card icon"/>
                <div className="dashboard-panel-title my-3">Credit card</div>
                <CreditCardSection mainCard={this.state.mainPaymentCard} />
                {this.state.party &&
                    <CardReuseCheckbox reuseCard={this.state.reuseCard} mainPaymentCard={this.state.mainPaymentCard}/>
                }
                <div className="px-3 my-4">
                    <Link
                        to="/dashboard/account/cardConsent"
                        className="btn btn-white-dashboard m-auto"
                        id="changeCard">
                        Change card
                    </Link>
                </div>
            </div>
        )
    }

    private refreshParty(): void {
        this.customerPortalService.getProfile().subscribe((output: Party) => {
            this.setMainPaymentCard(output);
            this.setState({
                party: output,
                reuseCard: output.reuseCard
            })
        });
    }

    private setMainPaymentCard(party: Party): void {
        const properties: CustomProperty[] = party.customProperties!;
        const cards: PaymentCard[] = party.paymentCards!;
        const mainCardProperty: CustomProperty[] = properties.filter(p => p.key === MAIN_PAYMENT_CARD);

        if (mainCardProperty) {
            const mainCards: PaymentCard[] = cards.filter(c => c.id.toString() === mainCardProperty[0].value);

            if (mainCards) {
                this.setState({
                    mainPaymentCard: mainCards[0]
                })
            }
        }
    }
}
